import NavBarGeral from "./NavBarGeral";
import SideBarGeral from "./SideBarGeral";

function MenuGeral() {
  return (
    <>
      <NavBarGeral />
      <SideBarGeral />
    </>
  );
}

export default MenuGeral;
